import React from 'react';
import { Helmet } from 'react-helmet';
import Cta from '../components/Cta';
import Faq from '../components/Faq';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import Hero1 from '../components/Hero1';
import Promo from '../components/Promo';
import Services1 from '../components/Services1';

function Home1() {
    return (
        <>
            <Helmet>
                <title>Work Express - Soluții Profesionale pentru Construcții și Renovări București</title>
                <meta name="description" content="Work Express oferă servicii profesionale de construcții și renovări în București. Specializați în izolații, hidroizolații, instalații electrice, vopsitorie, gips-carton, tencuieli și multe altele." />
                <meta name="keywords" content="constructii bucuresti, renovari bucuresti, izolatii, hidroizolatii, instalatii electrice, vopsitorie, gips-carton, tencuieli, sape, pardoseli, work express" />
                <meta property="og:title" content="Work Express - Soluții Profesionale pentru Construcții și Renovări" />
                <meta property="og:description" content="Companie fondată în 2017, dedicată furnizării soluțiilor eficiente și moderne pentru nevoile clienților noștri." />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://workexpress.ro/" />
            </Helmet>
            <Header1 />
            <Hero1 />
            <Promo />
            <Services1 />
            <Cta />
            <Faq />
            <Footer1 />
        </>
    );
}

export default Home1;
